import script from "./ImkpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ImkpPage.vue?vue&type=script&setup=true&lang=js"

import "./ImkpPage.vue?vue&type=style&index=0&id=6ab31a8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab31a8d"]])

export default __exports__